/**
 * AI 검색창 안내 문구.
 *
 * AI 검색은 이름 몇 글자가 아니라 조건을 문장으로 적는 곳이다. 그런데 빈 칸만
 * 놓아두면 무엇을 적어야 할지 알기 어렵다. 그래서 안내 문구 자체가 예시가 된다.
 *
 * 하나로 고정하면 그 한 가지 쓰임만 떠올리게 되므로, 화면에 들어올 때마다 바꾼다.
 */
export const AI_PLACEHOLDERS = [
  '"키 170 이상, 작품 경험 많은 배우" AI에게 자유롭게 물어보세요 (Enter)',
  '이름, 특기, 분위기, 경력까지 AI로 스마트하게 검색 (Enter)',
  '원하는 외모, 나이, 체격, 작품 경험을 프롬프트처럼 입력해보세요 (Enter)',
  '"로맨스 주연 경험 있는 20대 여배우" AI 맞춤 검색 (Enter)',
  '생김새, 신체조건, 이전 작품까지 AI로 한 번에 찾는 배우 검색 (Enter)',
  '배우 이름부터 AI 조건 검색, 캐스팅 프롬프트 입력까지 (Enter)',
  '"작품경험 많고 서구적인 외모의 배우" AI에게 물어보세요 (Enter)',
  '찾고 싶은 배우의 이미지와 조건을 AI에게 자유롭게 설명하세요 (Enter)',
  '이름·특기 검색 등 AI 맞춤 조건으로 이상적인 배우 찾기 (Enter)',
  '원하는 분위기, 키, 몸무게, 경력 등 AI 스마트 필터 검색 (Enter)',
];

/**
 * 문구 하나를 고른다.
 * @param {() => number} [random] 테스트에서 고정하기 위해 주입한다
 */
export function pickAiPlaceholder(random = Math.random) {
  const i = Math.floor(random() * AI_PLACEHOLDERS.length);
  // random()이 1을 돌려주는 구현이 있어 범위를 벗어날 수 있다
  return AI_PLACEHOLDERS[Math.min(i, AI_PLACEHOLDERS.length - 1)];
}
